import { type FC } from "react";
import { Button } from "@/components/flexkit/Button";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/podkit/dialog/Dialog";
import { TrackLocations } from "@/hooks/use-segment";

export type UnsavedChangesDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirmLeave: () => void;
};

export const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({ open, onOpenChange, onConfirmLeave }) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-track-location={TrackLocations.WorkflowEditPageUnsavedChangesDialog} className="w-96">
                <DialogHeader className="mb-0">
                    <DialogTitle>Unsaved changes</DialogTitle>
                    <DialogDescription>
                        You have unsaved changes. Your changes will be lost if you leave this page.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="justify-end">
                    <DialogClose asChild>
                        <Button variant="outline" data-tracking-id="stay">
                            Stay
                        </Button>
                    </DialogClose>
                    <Button variant="destructive" onClick={onConfirmLeave} data-tracking-id="leave">
                        Discard changes
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
